import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SponsorshipsService } from 'src/app/shared/services/sponsorships.service';

import { UpserviceService } from 'src/app/shared/services/upservice.service';

// import { PropertiesService } from 'src/app/shared/services/properties.service';
import { SponsorsService } from 'src/app/shared/services/sponsors.service';

import { MarketService } from '../../../shared/services/market.service';
import { ElasticSearchService } from 'src/app/shared/services/elastic-search.service';
import { SponsorshipRequestService } from 'src/app/shared/services/sponsorship-request.service';
import { Auth } from 'aws-amplify';
@Component({
  selector: 'app-edit-sponsorship-request',
  templateUrl: './edit-sponsorship-request.component.html',
  styleUrls: ['./edit-sponsorship-request.component.css'],

})
export class EditSponsorshipRequestComponent implements OnInit {

  editSponsorshipForm: FormGroup;
  isLoading: boolean = false;
  loading: boolean = false;
  display: boolean = false;

  isSearchingProperties: boolean = false;
  propertiesResults: boolean = false;
  propertiesSearchResults: any = [];

  isSearchingSponsors: boolean = false;
  sponsorsResults: boolean = false;
  sponsorsSearchResults: any = [];

  selectedProperty: any = {};
  selectedSponsor: any = {};
  displaySelectedProperty: boolean = false;
  propertySearchError: boolean = false;
  sponsorsSearchError: boolean = false;
  displaySelectedSponsor: boolean = false;
  propertyValid: boolean = false;
  sponsorValid: boolean = false;
  owner: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sponsorshipsReqService: SponsorshipRequestService,
    private upService: UpserviceService,
    private marketService: MarketService,
    private sponsorsService : SponsorsService,
    private elasticSearchService: ElasticSearchService) {
    this.getCurrentAuthenticatedUser();
    this.editSponsorshipForm = this.fb.group({
      name: [''],
      value: [''],
      status: [''],
      type: [''],
      sponsorName: [''],
      propertyName: ['']
    });
  }

  recievedSponsorship: any;

  customStylesValidated = false;

  ngOnInit(): void {
    this.isLoading = true;
    this.route.queryParams.subscribe((params) => {
      this.recievedSponsorship = params;
      
      setTimeout(() => {
        this.isLoading = false;
        this.updateForm();
      }, 1000);
      console.log('recievedSponsorship: ', this.recievedSponsorship);
    });


  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  updateForm() {
    const formValues = {
      name: [
        this.recievedSponsorship.name ? this.recievedSponsorship.name : '',
      ],
      value: [
        this.recievedSponsorship.value ? this.recievedSponsorship.value : '',
      ],
      status: [
        this.recievedSponsorship.status ? this.recievedSponsorship.status : '',
      ],
      type: [
        this.recievedSponsorship.type ? this.recievedSponsorship.type : '',
      ],
      sponsorName: [
        this.recievedSponsorship.sponsorName ? this.recievedSponsorship.sponsorName : '',
      ],
      propertyName: [
        this.recievedSponsorship.propertyName ? this.recievedSponsorship.propertyName : '',
      ]
    };

    this.getPropertyById(this.recievedSponsorship.propertyId);    //get property by Id
    this.getSponsorById(this.recievedSponsorship.sponsorId);    //Get sponsor by Id

    this.editSponsorshipForm = this.fb.group(formValues); //populate form with current values
  }

  getPropertyById(propertyId: any) {
    this.isSearchingProperties = true;

    this.marketService.getPropertyById(propertyId).subscribe((data) => {
      this.isSearchingProperties = false;

      this.selectedProperty = data;
      this.displaySelectedProperty = true;
      this.propertiesResults = true;
      console.log("getPropertyById", this.selectedProperty);

    }, err => {
      this.isSearchingProperties = false;
      this.selectedProperty = {
        name: this.recievedSponsorship.propertyName,
        propertyId: this.recievedSponsorship.propertyId
      };
      this.displaySelectedProperty = true;
      this.propertiesResults = true;
      console.log("selectedProperty", this.selectedProperty);

      console.log(err);
    });

  }

  getSponsorById(sponsorId: any) {
    this.isSearchingSponsors = true;

    this.sponsorsService.getSponsorsBySponsorId(sponsorId).subscribe(data => {
      this.isSearchingSponsors = false;
      console.log("getSponsorsBySponsorId", data);

      if (data.length) {
        this.selectedSponsor = data[0];
      } else {
        this.selectedSponsor = {
          name: this.recievedSponsorship.sponsorName,
          sponsorId: this.recievedSponsorship.sponsorId
        };
      }
      this.displaySelectedSponsor = true;
      this.sponsorsResults = true;
      console.log("selectedSponsor", this.selectedSponsor);

    }, err => {
      this.isSearchingSponsors = false;

      this.selectedSponsor = {
        name: this.recievedSponsorship.sponsorName,
        sponsorId: this.recievedSponsorship.sponsorId
      };
      this.displaySelectedSponsor = true;
      this.sponsorsResults = true;
      console.log("selectedSponsor", this.selectedSponsor);
      console.log(err);
    });
  }

  convertTimestampToDate(timestamp: any) {
    return new Date(parseInt(timestamp)).toISOString().slice(0, 10);
  }

  onSubmitEditForm() {

    this.customStylesValidated = true;

    if (Object.keys(this.selectedProperty).length)
      this.propertyValid = true;
    else
      this.propertyValid = false;

    if (Object.keys(this.selectedSponsor).length)
      this.sponsorValid = true;
    else
      this.sponsorValid = false;

    if (this.editSponsorshipForm.valid &&
      this.propertyValid &&
      this.sponsorValid) {

        this.loading = true;
          

        var updatedSponsorshipValues = this.editSponsorshipForm.value;

        updatedSponsorshipValues['propertyName'] = this.selectedProperty.name;       //inject property and sponsor details
        updatedSponsorshipValues['propertyId'] = this.selectedProperty.propertyId;
        updatedSponsorshipValues['sponsorName'] = this.selectedSponsor.name;
        updatedSponsorshipValues['sponsorId'] = this.selectedSponsor.sponsorId;
        updatedSponsorshipValues['sponsorshipRequestId'] = this.recievedSponsorship.sponsorshipRequestId;

        console.log('Form submitted', updatedSponsorshipValues);

        this.sponsorshipsReqService
          .updateSponsorshipReq(updatedSponsorshipValues)
          .subscribe(
            (data) => {
             
              console.log('Results: ', data);
              setTimeout(() => {
                this.loading = false;
                this.router.navigate(['private-space/view-sporsorship-requests', {}]);
              }, 1000); 

              const queryParams: Params = updatedSponsorshipValues;


            },
            (error) => {

              this.loading = false;
              console.log('Error: ', error);
              // alert('The was an error while updating this Sponsorship!');
            }
          );
    } else {
      this.display = true;
      this.loading = false;
    }
  }

  onSearchProperties(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingProperties = true;

      this.elasticSearchService.searchProperty(event.target.value, this.owner).subscribe(
        (data) => {
          this.isSearchingProperties = false;
          this.propertiesResults = true; //display the results
          this.propertiesSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.propertySearchError = true;
          }
          // console.log('Elastic Search', data);
          // console.log('Search results: ', this.propertiesSearchResults);
        },
        (error) => {
          this.isSearchingProperties = false;
          // console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingProperties = false;
      if (Object.keys(this.selectedProperty).length === 0) {
        this.propertiesResults = false; //hide the results
      }
    }
  }

  onSearchSponsors(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingSponsors = true;

      // console.log('Keyup: ', event.target.value);

      this.elasticSearchService.searchSponsor(event.target.value).subscribe(
        (data) => {
          this.isSearchingSponsors = false;
          this.sponsorsResults = true; //display the results
          this.sponsorsSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.sponsorsSearchError = true;
          }
          // console.log('Elastic Search', data);
          // console.log('Search results: ', this.sponsorsSearchResults);
        },
        (error) => {
          this.isSearchingSponsors = false;
          console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingSponsors = false;
      if (Object.keys(this.selectedSponsor).length === 0) {
        this.sponsorsResults = false; //hide the results
      }
    }
  }

  onSelectProperty(property: any, propertyId: any) {
    this.propertiesSearchResults = []; //hide the results
    property['propertyId'] = propertyId;
    console.log('selected Property: ', property);
    this.selectedProperty = property;
    this.displaySelectedProperty = true;

    this.editSponsorshipForm.patchValue({
      propertyName: property.name
    });
  }

  onSelectSponsor(sponsor: any, sponsorId: any) {
    this.sponsorsSearchResults = []; //hide the results
    sponsor['sponsorId'] = sponsorId;
    console.log('selected Sponsor: ', sponsor);
    this.selectedSponsor = sponsor;
    this.displaySelectedSponsor = true;

    this.editSponsorshipForm.patchValue({
      sponsorName: sponsor.name
    });
  }

  removeProperty() {
    this.editSponsorshipForm.patchValue({
      propertyName: ''
    });
    this.selectedProperty = {};
    this.propertiesResults = false;
    this.displaySelectedProperty = false;
  }

  removeSponsor() {
    this.editSponsorshipForm.patchValue({
      sponsorName: ''
    });
    this.selectedSponsor = {};
    this.sponsorsResults = false;
    this.displaySelectedSponsor = false;
  }
}
